export const FONT_AWESOME_TO_ICONOIR: Record<string, string> = {
  addresscard: 'User',
  addresscardalt: 'User',
  alignleft: 'List',
  analytics: 'GraphUp',
  angleleft: 'NavArrowLeft',
  angleright: 'NavArrowRight',
  angledown: 'NavArrowDown',
  angleup: 'NavArrowUp',
  archive: 'Archive',
  arrowaltcircledown: 'ArrowDown',
  arrowaltcircleleft: 'ArrowLeft',
  arrowaltcircleright: 'ArrowRight',
  arrowaltcircleup: 'ArrowUp',
  arrowcircledown: 'ArrowDown',
  arrowcircleleft: 'ArrowLeft',
  arrowcircleright: 'ArrowRight',
  arrowcircleup: 'ArrowUp',
  arrowsalt: 'SelectPoint3d',
  award: 'BadgeCheck',
  ban: 'Xmark',
  barcode: 'ViewGrid',
  bars: 'Menu',
  bolt: 'Sparks',
  bookopen: 'BookStack',
  books: 'BookStack',
  boxalt: 'Box',
  boxes: 'Package',
  boxopen: 'Package',
  brain: 'BrainResearch',
  building: 'Home',
  bullseye: 'Position',
  calendaralt: 'Calendar',
  calendarcheck: 'Calendar',
  calendarday: 'Calendar',
  calendarweek: 'Calendar',
  caretleft: 'NavArrowLeft',
  caretright: 'NavArrowRight',
  caretdown: 'NavArrowDown',
  caretup: 'NavArrowUp',
  chalkboard: 'Book',
  chartarea: 'GraphUp',
  chartbar: 'StatsUpSquare',
  chartline: 'GraphUp',
  chartpie: 'StatsUpSquare',
  checksquare: 'BadgeCheck',
  chevronleft: 'NavArrowLeft',
  chevronright: 'NavArrowRight',
  chevrondown: 'NavArrowDown',
  chevronup: 'NavArrowUp',
  clipboard: 'Page',
  clipboardcheck: 'BadgeCheck',
  clipboardlist: 'List',
  clone: 'Copy',
  close: 'Xmark',
  cloud: 'Cloud',
  clouddownload: 'Download',
  clouddownloadalt: 'Download',
  cloudupload: 'Upload',
  clouduploadalt: 'Upload',
  codebranch: 'GitBranch',
  codecommit: 'GitCommit',
  codefork: 'GitFork',
  codemerge: 'GitMerge',
  cog: 'Settings',
  cogs: 'Settings',
  coins: 'CreditCard',
  comment: 'Message',
  commentalt: 'MessageText',
  comments: 'ChatBubble',
  compass: 'Position',
  compress: 'Collapse',
  compressalt: 'Collapse',
  copy: 'Copy',
  creditcard: 'CreditCard',
  crop: 'DesignPencil',
  cropalt: 'DesignPencil',
  crosshairs: 'Position',
  cubes: 'Cube',
  cut: 'Copy',
  database: 'Database',
  desktop: 'Computer',
  defaulticon: 'SelectPoint3d',
  dollarsign: 'CreditCard',
  doorclosed: 'LogOut',
  dooropen: 'LogIn',
  drawpolygon: 'SelectPoint3d',
  edit: 'EditPencil',
  ellipsish: 'MoreVert',
  ellipsisv: 'MoreVert',
  envelope: 'Mail',
  envelopeopen: 'Mail',
  envelopeopentext: 'Mail',
  eraser: 'Trash',
  exchange: 'Refresh',
  exchangealt: 'Refresh',
  exclamation: 'WarningTriangle',
  exclamationcircle: 'WarningCircle',
  exclamationtriangle: 'WarningTriangle',
  expand: 'Plus',
  expandalt: 'Plus',
  externallink: 'Link',
  externallinkalt: 'Link',
  eyedropper: 'Palette',
  eyeslash: 'EyeClosed',
  fax: 'Headset',
  file: 'Page',
  filealt: 'Page',
  filearchive: 'Archive',
  filecode: 'Code',
  filecontract: 'Page',
  filecsv: 'Page',
  filedownload: 'Download',
  fileexcel: 'Page',
  fileexport: 'Upload',
  fileimage: 'Camera',
  fileimport: 'Download',
  fileinvoice: 'Page',
  fileinvoicedollar: 'CreditCard',
  filepdf: 'Page',
  filesignature: 'PageEdit',
  fileupload: 'Upload',
  fileword: 'Page',
  filldrip: 'Palette',
  film: 'Camera',
  fingerprint: 'Lock',
  folderopen: 'Folder',
  folderplus: 'Folder',
  gear: 'Settings',
  gears: 'Settings',
  gem: 'Star',
  gitalt: 'GitBranch',
  github: 'GitBranch',
  gitlab: 'GitBranch',
  globeamericas: 'Globe',
  globeasia: 'Globe',
  globeeurope: 'Globe',
  graduationcap: 'GraduationCap',
  griphorizontal: 'ViewGrid',
  gripvertical: 'ViewGrid',
  hdd: 'Database',
  headphones: 'Headset',
  highlighter: 'DesignPencil',
  hourglass: 'Clock',
  hourglasshalf: 'Clock',
  idcard: 'User',
  image: 'Camera',
  images: 'Camera',
  inbox: 'Archive',
  industry: 'Server',
  info: 'InfoCircle',
  infocircle: 'InfoCircle',
  keyboard: 'Computer',
  laptop: 'Computer',
  laptopcode: 'Code',
  layergroup: 'Component',
  lightbulb: 'Lamp',
  link: 'Link',
  listol: 'List',
  listul: 'List',
  locationarrow: 'Position',
  lockopen: 'Lock',
  longarrowaltdown: 'FastArrowDown',
  longarrowaltleft: 'ArrowLeft',
  longarrowaltright: 'ArrowRight',
  longarrowaltup: 'FastArrowUp',
  magic: 'Sparks',
  mapmarker: 'Position',
  mapmarkeralt: 'Position',
  mappin: 'Position',
  medal: 'BadgeCheck',
  memory: 'Cpu',
  microchip: 'Cpu',
  minuscircle: 'Minus',
  minussquare: 'Minus',
  mobile: 'Computer',
  mobilealt: 'Computer',
  networkwired: 'Network',
  newspaper: 'Page',
  objectgroup: 'Component',
  paintbrush: 'DesignPencil',
  paperclip: 'Link',
  paperplane: 'Send',
  paste: 'Copy',
  pen: 'EditPencil',
  penalt: 'EditPencil',
  pencil: 'EditPencil',
  pencilalt: 'EditPencil',
  percent: 'GraphUp',
  phone: 'Headset',
  phonealt: 'Headset',
  photovideo: 'Camera',
  plug: 'Link',
  plussquare: 'PlusCircle',
  poweroff: 'LogOut',
  projectdiagram: 'GitFork',
  puzzlepiece: 'Component',
  qrcode: 'ViewGrid',
  question: 'HelpCircle',
  questioncircle: 'HelpCircle',
  random: 'Refresh',
  recycle: 'Refresh',
  redo: 'Refresh',
  redoalt: 'Refresh',
  save: 'Download',
  school: 'GraduationCap',
  sdcard: 'Database',
  searchminus: 'Search',
  searchplus: 'Search',
  shapes: 'SquareDashed',
  share: 'ShareIos',
  sharealt: 'ShareIos',
  shieldalt: 'Shield',
  signin: 'LogIn',
  signinalt: 'LogIn',
  signout: 'LogOut',
  signoutalt: 'LogOut',
  sitemap: 'Network',
  sliders: 'Settings',
  slidersh: 'Settings',
  sort: 'Filter',
  sparkles: 'Sparks',
  square: 'SquareDashed',
  star: 'Star',
  sticky: 'Page',
  stickynote: 'Page',
  stopwatch: 'Clock',
  stream: 'List',
  sun: 'Lamp',
  swatchbook: 'Palette',
  sync: 'Refresh',
  syncalt: 'RefreshDouble',
  tablet: 'Computer',
  tabletalt: 'Computer',
  tasks: 'List',
  th: 'ViewGrid',
  thlarge: 'ViewGrid',
  thlist: 'List',
  thumbtack: 'Position',
  times: 'Xmark',
  timescircle: 'Xmark',
  tools: 'Settings',
  trashalt: 'Trash',
  trashrestore: 'Undo',
  trophy: 'BadgeCheck',
  tv: 'Airplay',
  undoalt: 'Undo',
  university: 'GraduationCap',
  unlink: 'Link',
  unlock: 'Lock',
  unlockalt: 'Lock',
  userfriends: 'Group',
  userlock: 'Lock',
  users: 'Group',
  usershield: 'Shield',
  vectorsquare: 'Component',
  vial: 'TestTube',
  vials: 'TestTube',
  video: 'Camera',
  wallet: 'CreditCard',
  warehouse: 'Archive',
  wifi: 'Network',
  windowclose: 'Xmark',
  wrench: 'Settings'
};

const stripFontAwesomePrefix = (name: string): string => {
  if (/^fa-/i.test(name)) {
    return name.slice(3);
  }

  if (/^Fa[A-Z]/.test(name)) {
    return name.slice(2);
  }

  return name;
};

export const normalizeIconName = (name: string): string =>
  stripFontAwesomePrefix(name.trim())
    .replace(/[-_\s]+/g, '')
    .toLowerCase();
